export const SocialProviders = {
  AppleLoginButton: 'apple-login-button',
  GoogleLoginButton: 'google-login-button',
}